/**
 * @param score A value between -100 and +100
 * @returns A value between 0 and 180 (degrees)
 */
export function calcRotation(score: number): number {
  return (score + 100) * 0.9;
}
